import Sidebar from 'semantic-ui-react/dist/commonjs/modules/Sidebar';
import '@purple/semantic-ui-purple-theme/components/sidebar.css';

export default Sidebar;
